import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { currentUser } from 'store/user/selectors';

/**
 * Keeps the Sentry user in step with the signed-in user. Sentry only indexes a top-level `id` for
 * `user.id:<uuid>` search and "users affected", so only the uuid is sent; it is cleared while nobody is
 * signed in.
 */
export const useSentryUser = (): void => {
  const userUuid = useSelector(currentUser)?.uuid;

  useEffect(() => {
    Sentry.setUser(userUuid ? { id: userUuid } : null);
  }, [userUuid]);
};
